import { render, staticRenderFns } from "./invoiceStatus.vue?vue&type=template&id=6d80254e&scoped=true&"
import script from "./invoiceStatus.vue?vue&type=script&lang=js&"
export * from "./invoiceStatus.vue?vue&type=script&lang=js&"
import style0 from "./invoiceStatus.vue?vue&type=style&index=0&id=6d80254e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d80254e",
  null
  
)

export default component.exports